import { AfterContentInit, Directive, ElementRef, Input } from "@angular/core";
/**
 * @example  <div [uiBoldTerm]="TextToFind">  {{ fullTextContainingSearch }} </div>
 * @param boldTerm string
 * @param boldTermClass string (default: fw-800)
 */
@Directive({
  selector: "[uiBoldTerm], [ui-bold-term]",
})
export class UiBoldTermDirective implements AfterContentInit {
  @Input("uiBoldTerm") public boldTerm: string;

  @Input() public boldTermClass = "fw-800";

  constructor(private el: ElementRef) {}

  public ngAfterContentInit(): void {
    const domElement = this.el.nativeElement as HTMLElement;
    if (domElement.children.length === 0 && this.boldTerm) {
      domElement.innerHTML = domElement.innerHTML.replace(new RegExp("(\\b" + this.boldTerm + ")", "gi"), `<span class='${this.boldTermClass}'>${this.boldTerm}</span>`);
    }
  }
}
